/**
 * A container for a value that should be retrieved **asynchronously, but only once**.
 * The value **is obtained lazily** the first time method {@link LazyAsyncOnceClass.getValue} is called.
 *
 * @template T Type of value
 */
export class LazyAsyncOnceClass<T> {
  private pendingResult: Promise<T>;

  public constructor(
    private readonly factory: () => Promise<T>,
  ) {
  }

  /**
   * Get value from container:
   *   - If async operation not started yet, then it will be started;
   *   - If async operation in progress or finished, then `Promise` will be returned;
   * @returns
   */
  public getValue = (): Promise<T> => {
    if (!this.pendingResult) {
      this.pendingResult = this.factory();
    }

    return this.pendingResult;
  };
}
